__turbopack_export_value__({
  "body-logo-18": "ControlledInput-module-scss-module__3Ysi9a__body-logo-18",
  "body-text-12": "ControlledInput-module-scss-module__3Ysi9a__body-text-12",
  "body-text-14": "ControlledInput-module-scss-module__3Ysi9a__body-text-14",
  "body-text-16": "ControlledInput-module-scss-module__3Ysi9a__body-text-16",
  "body-text-18": "ControlledInput-module-scss-module__3Ysi9a__body-text-18",
  "body-text-20": "ControlledInput-module-scss-module__3Ysi9a__body-text-20",
  "body-text-24": "ControlledInput-module-scss-module__3Ysi9a__body-text-24",
  "body-text-24-2": "ControlledInput-module-scss-module__3Ysi9a__body-text-24-2",
  "body-text-heading-2": "ControlledInput-module-scss-module__3Ysi9a__body-text-heading-2",
  "body-text-heading-3": "ControlledInput-module-scss-module__3Ysi9a__body-text-heading-3",
  "body-text-medium-14": "ControlledInput-module-scss-module__3Ysi9a__body-text-medium-14",
  "body-text-medium-16": "ControlledInput-module-scss-module__3Ysi9a__body-text-medium-16",
  "body-text-medium-18": "ControlledInput-module-scss-module__3Ysi9a__body-text-medium-18",
  "body-text-medium2-18": "ControlledInput-module-scss-module__3Ysi9a__body-text-medium2-18",
  "body-text2-14": "ControlledInput-module-scss-module__3Ysi9a__body-text2-14",
  "body-text2-16": "ControlledInput-module-scss-module__3Ysi9a__body-text2-16",
  "button-primary-text": "ControlledInput-module-scss-module__3Ysi9a__button-primary-text",
  "button-text": "ControlledInput-module-scss-module__3Ysi9a__button-text",
  "button2-text": "ControlledInput-module-scss-module__3Ysi9a__button2-text",
  "card-shadow": "ControlledInput-module-scss-module__3Ysi9a__card-shadow",
  "effect-menu": "ControlledInput-module-scss-module__3Ysi9a__effect-menu",
  "header-1": "ControlledInput-module-scss-module__3Ysi9a__header-1",
  "input": "ControlledInput-module-scss-module__3Ysi9a__input",
  "inputWrapper": "ControlledInput-module-scss-module__3Ysi9a__inputWrapper",
  "inputWrapper__label": "ControlledInput-module-scss-module__3Ysi9a__inputWrapper__label",
  "input__cross": "ControlledInput-module-scss-module__3Ysi9a__input__cross",
  "input__cross_shifted": "ControlledInput-module-scss-module__3Ysi9a__input__cross_shifted",
  "input__errorHint": "ControlledInput-module-scss-module__3Ysi9a__input__errorHint",
  "input__errorHint_visible": "ControlledInput-module-scss-module__3Ysi9a__input__errorHint_visible",
  "input_disabled": "ControlledInput-module-scss-module__3Ysi9a__input_disabled",
  "input_error": "ControlledInput-module-scss-module__3Ysi9a__input_error",
  "main-container": "ControlledInput-module-scss-module__3Ysi9a__main-container",
  "main-footer-container": "ControlledInput-module-scss-module__3Ysi9a__main-footer-container",
  "main-header-container": "ControlledInput-module-scss-module__3Ysi9a__main-header-container",
  "txt-12-bold": "ControlledInput-module-scss-module__3Ysi9a__txt-12-bold",
  "txt-14-bold": "ControlledInput-module-scss-module__3Ysi9a__txt-14-bold",
  "txt-14-bold-caps": "ControlledInput-module-scss-module__3Ysi9a__txt-14-bold-caps",
  "txt-14-med": "ControlledInput-module-scss-module__3Ysi9a__txt-14-med",
  "txt-16-bold": "ControlledInput-module-scss-module__3Ysi9a__txt-16-bold",
  "txt-16-med": "ControlledInput-module-scss-module__3Ysi9a__txt-16-med",
  "txt-18-bold": "ControlledInput-module-scss-module__3Ysi9a__txt-18-bold",
  "txt-18-medium": "ControlledInput-module-scss-module__3Ysi9a__txt-18-medium",
  "txt-18-medium-24": "ControlledInput-module-scss-module__3Ysi9a__txt-18-medium-24",
  "txt-24-semi": "ControlledInput-module-scss-module__3Ysi9a__txt-24-semi",
});
